import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {IndigoHeader} from './IndigoHeader';
import {IndigoFooter} from './IndigoFooter';


class Shipping{
    key: number
    title?: string;
    Content?: any;
}
const letterSpace = '2px';

const multiLineStyle: CSSProperties = {
    textAlign:'left',
    padding:'10px'
}
const answerStyle:CSSProperties = {
    letterSpacing:'normal',
    paddingTop:'16px',
    paddingBottom:'16px'
}
const proofEditLinkStyle: CSSProperties = {
    textDecoration:'underline',
    color:'blue'
}
const pageStyle: CSSProperties = {
    backgroundColor:'#F7F5F0'
}
const salesEmail: CSSProperties = {
    color:'blue',
    textDecoration:'underline'
}
const timeLineImg: CSSProperties = {
    width:'100%'
}
const timeLineHdr: CSSProperties = {
    fontFamily:"AveriaSerifBold",
    fontSize:'19px',
    textTransform:'uppercase',
    marginTop:'26px'
}
const timeLineTitle: CSSProperties = {
    fontSize:'22px',
    textAlign:'center',
}
const timeLineTitle1: CSSProperties = {
    fontSize:'22px',
    textAlign:'center',
    marginTop:'50px'
}
const haveArt: CSSProperties = {
    marginTop:'20px',
    textAlign:'center'
}

const shippingMap: CSSProperties = {
    width:'100%'
}
var minOrderStyle = Object.assign({},multiLineStyle,{fontSize:'16px',letterSpacing:letterSpace})

let Questions: Shipping[] = [
{
    key: 1,
    title: "",
    Content: <div><div style={timeLineTitle}>Production Times: I Have Art&#42;</div><div style={timeLineHdr}>Screen Printing</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/SCRN_IHA.png')}/><div style={timeLineHdr}>Screen Printing - Rush</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/SCRN_IHA_RUSH.png')}/><div style={timeLineHdr}>Embroidery</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/EMBR_IHA.png')}/><div style={timeLineHdr}>Embroidery - Rush</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/EMBR_IHA_RUSH.png')}/><div style={haveArt}>*All art, production, and shipping times are average turn times. The printing timeframe does not begin until you have approved your proof, submitted apparel sizes, and confirmed payment details. Shipping times are based on ground service, expedited shipping options are available. The Graphic cow is not responsible for delays in shipping/transit time.</div><div style={timeLineTitle1}>Production Times: I Need Art&#42;</div><div style={timeLineHdr}>Screen Printing</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/SCRN_INA.png')}/><div style={timeLineHdr}>Screen Printing - Rush</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/SCRN_INA_RUSH.png')}/><div style={timeLineHdr}>Embroidery</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/EMBR_INA.png')}/><div style={timeLineHdr}>Embroidery - Rush</div><img style={timeLineImg} src={Tgcc.ResolveUrl('~/images/EMBR_INA_RUSH.png')}/><div style={answerStyle}>*All art, production, and shipping times are average turn times. The printing timeframe does not begin until you have approved your proof, submitted apparel sizes, and confirmed payment details. Shipping times are based on ground service, expedited shipping options are available. The Graphic cow is not responsible for delays in shipping/transit time.
    **Art for rushed embroidery jobs usually consists of basic text and logo style work, design requests that are more detailed will require more art preparation time.</div></div>
},{ 
    key:2,
    title:"Standard Shipping",
    Content:<div><img style={shippingMap} src={Tgcc.ResolveUrl('~/images/ShippingMap-01.jpg')}/></div>
},{
    key: 3,
    title: "Expedited Shipping",
    Content: <div style={answerStyle}>We do offer a rush service for most apparel orders. Rushing an order would add a 10% rush fee to your order and would guarantee a 3-4 business day turnaround for screen printed items and 7-10 business days for embroidered items. Overnight or priority shipping charges may apply depending on the shipping location. For more details on expediting your order, please reach out to us at 800-472-3269 x2.</div>

},{
    key: 4,
    title: "Individual Link Shipments",
    Content:<div style={answerStyle}>All orders placed through our individual payment/sign-up links will ship in bulk to the address determined by the main buyer. If you’re not sure who set up your order, call us at 800-472-3269.</div>
},{
    key: 5,
    title: "Returns",
    Content: <div style={answerStyle}>We stand behind our products and the services we offer. If you receive incorrect or damaged product, please contact <a href="mailto:sales@grafcow.com" style={salesEmail}>sales@grafcow.com</a> with details of the issue, full refunds will be given on any confirmed damaged or misprinted goods reported within 5 business days of receipt. </div>
}
];

const itemStyle: CSSProperties = {
    fontSize: '13px',
    padding: '5px',
    margin: '11px 10px',
    letterSpacing: '2px',
    borderBottom:'1px solid rgba(87,144,161,0.2)',
    fontFamily:'AveriaSerifLight',
    color:'#616060'
}

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin:'auto auto 200px auto',
    width:'43%'
}
const FAQHdr :CSSProperties = {
    textAlign:'center',
    fontFamily:'AveriaSerifLightItalic',
    color:'#616060'
}

const titleStyle: CSSProperties = {
    fontFamily:'Reitam',
    color:'#616060',
    fontSize:'14px',
    letterSpacing:'normal'
}

const contentStyle: CSSProperties = {
    fontFamily:'AveriaSerifRegular',
    color:'#7C726E'
}
const FAQSubHdr: CSSProperties = {
    textAlign:'center',
    fontFamily:'AveriaSerifLight',
    color:'#7C726E',
    width:'34%',
    margin:'auto'
}


class _IndigoShipping extends React.Component<Tgcc.BaseProps, any>{

    componentDidMount(){
        var tag = document.getElementById('Shipping');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

  
    render(){
        return (
                <div style={pageStyle}>
                    <div id="Shipping"></div>
                    <IndigoHeader />
                    <h2 style={FAQHdr}>Turn Around &#38; Returns</h2>
                    <div style={FAQSubHdr} className="corpTurnAround">We pride ourselves on making sure you get your order on time. Check out our Standard Production Timelines below(in business days):</div>
                    <div style={containerStyle} className='shippingCont'>
                        {Questions.map( (question: Shipping) => { 
                        return (<div key={question.key} style={itemStyle}>
                                    <div style={titleStyle}>{question.title}</div><br/>
                                    <div style={contentStyle}>{question.Content}</div>
                                </div>)})}
                    </div>
                    <IndigoFooter state={this.props.state} />
                </div>
            
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { 
        state: state
    }
};
export var IndigoShipping = connect(mapStateToProps)(_IndigoShipping)